import { render, staticRenderFns } from "./IdeasGrid.vue?vue&type=template&id=6afa4eac&scoped=true&"
import script from "./IdeasGrid.vue?vue&type=script&lang=js&"
export * from "./IdeasGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afa4eac",
  null
  
)

export default component.exports